export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineDeviation.worker.04a4e569fe6d56312acf-engineDeviation.worker.worker.js");
}
